import React from 'react'
import * as _ from 'recompose'
import { connect } from 'react-redux'
import { injectIntl, FormattedMessage } from 'react-intl'

const locales = {
  en: { code: 'en', 'title': 'English' },
  ru: { code: 'ru', 'title': 'Русский' }
}

const Component = ({
  confirm,
  setLocale,
  setCountry,
  locale = null,
  countryId = null,
  countries = {},
  intl
}) => (
  <div className='Region'>
    <h1 className='Region-h1'><FormattedMessage id='regions.title' /></h1>
    <p className='Region-kaption'><FormattedMessage id='regions.disclaimer' /></p>
    <div className='Region-kontainer'>
      <div className='Region-select'>
        <span className='Region-select-label'>{countryId ? countries[countryId].title : intl.formatMessage({ id: 'regions.setCountryPlaceholder' })}</span>
        <select onChange={setCountry} value={countryId || ''}>
          <option value={null} />
          {Object.values(countries).map(item => (
            <option key={item.countryId} value={item.countryId}>{item.title}</option>
          ))}
        </select>
      </div>

      <div className='Region-select'>
        <span className='Region-select-label'>{locale ? locales[locale].title : intl.formatMessage({ id: 'regions.setLanguagePlaceholder' })}</span>
        <select onChange={setLocale} value={locale || ''}>
          <option value={null} />
          {Object.values(locales).map(locale => (
            <option value={locale.code} key={locale.code}>{locale.title}</option>
          ))}
        </select>
      </div>

      <button className='Region-submit' onClick={confirm}><FormattedMessage id='regions.done' /></button>
    </div>
  </div>
)

const mapState = state => ({
  countries: state.countries
})

export default _.compose(
  injectIntl,
  connect(mapState),
  _.withStateHandlers(
    {
      countryId: window.localStorage.getItem('countryId'),
      locale: window.localStorage.getItem('locale')
    },
    {
      setLocale: () => e => ({ locale: e.target.value }),
      setCountry: () => e => ({ countryId: e.target.value })
    }
  ),
  _.withHandlers({
    confirm: ({ countryId, locale }) => e => {
      e && e.preventDefault()
      if (!countryId || !locale) return null
      window.localStorage.setItem('locale', locale)
      window.localStorage.setItem('countryId', countryId)
      window.location.reload()
    }
  }),
  _.branch(({ countries }) => !Object.keys(countries).length, _.renderNothing)
)(Component)



// WEBPACK FOOTER //
// ./src/components/Region/Region.jsx